const URLS = {
  RCM: 'https://www.rcm.at/',
  RCMI: 'https://www.rcm-international.com/',
  RSI: 'https://www.raiffeisen-salzburg-invest.at/',
};
export const folderMap = {
  'rcm-int': URLS.RCMI,
  'bg-en': URLS.RCMI,
  'bg-bg': URLS.RCMI,
  'ch-de': URLS.RCMI,
  'ch-en': URLS.RCMI,
  'cz-en': URLS.RCMI,
  'de-de': URLS.RCMI,
  'es-en': URLS.RCMI,
  'fr-fr': URLS.RCMI,
  'hr-en': URLS.RCMI,
  'hu-en': URLS.RCMI,
  'it-it': URLS.RCMI,
  'li-de': URLS.RCMI,
  'lu-en': URLS.RCMI,
  'pl-en': URLS.RCMI,
  'ro-en': URLS.RCMI,
  'si-en': URLS.RCMI,
  'sk-en': URLS.RCMI,
  'not-found': URLS.RCMI,
  'at-de': URLS.RCM,
  'at-en': URLS.RCM,
  'at-it': URLS.RCM,
  'at-golfmeisterschaft': URLS.RCM,
  'at-rsi': URLS.RSI,
  de: URLS.RSI,
};
